import { colInitials } from "./initials";

export const colCourseLogo = colInitials
